import React from "react";

const GetDealRows = (deal, columns) => (
  <>
    {columns.map(({ id, Cell }) => (Cell ? <Cell className="pipeline-card-value" key={id} deal={deal} /> : null))}
  </>
);

export default GetDealRows;
